import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { getQuizQuestions } from 'graphql/queries';
import { Crawler } from './crawler';
import { QuizQuestions, QuizQuestionsVariables } from 'graphql/queries/types/QuizQuestions';
import { useEventContext, useQuizContext } from 'contexts';
import { BattleshipQuiz } from './battleship-quiz';
import { ErrorLocal, Spinner } from 'components';
import { BattleshipSetup } from './setup/battleship-setup';
import { BattleshipQuizSetup } from './types';

import './styles/battleship.css';

interface Props {}

enum Scenes {
    Setup,
    Crawler,
    Quiz
}

export const BattleshipBase = (props: Props) => {
    const [quizSetup, setQuizSetup] = useState<BattleshipQuizSetup>();
    const [currentScene, setCurrentScene] = useState(Scenes.Setup);

    const eventContext = useEventContext();
    const { quiz } = useQuizContext();

    const {
        loading,
        error,
        data: quizQuestions
        // refetch
    } = useQuery<QuizQuestions, QuizQuestionsVariables>(getQuizQuestions, {
        variables: { quizId: quiz.id! }
    });

    if (loading) return <Spinner />;
    if (error) return <ErrorLocal errorMessage="Error getting quiz questions :(" errorDetails={error} />;
    if (!quizQuestions) return <p>No data</p>;

    const onQuizStart = (quizSetup: BattleshipQuizSetup) => {
        setQuizSetup(quizSetup);
        setCurrentScene(Scenes.Quiz);
    };

    const scenes = {
        [Scenes.Setup]: () => <BattleshipSetup quizQuestions={quizQuestions} onQuizStart={onQuizStart} />,
        [Scenes.Crawler]: () => <Crawler onClearCrawler={() => setCurrentScene(Scenes.Quiz)} />,
        [Scenes.Quiz]: () => (
            <BattleshipQuiz
                eventLogo={eventContext?.logo_url}
                gridColumns={quizSetup!.columns}
                gridRows={quizSetup!.rows}
                teams={quizSetup!.teams}
                quizQuestions={quizQuestions}
                gameType={quizSetup!.gameType}
                cooldownSeconds={quizSetup?.cooldownSec}
            />
        )
    };

    return scenes[currentScene]();
};
